import Env from '@/utils/environment-details'

const initialState = () => ({
  orientation: null,
  screen_size: null,
  scroll_offset: null,
  window_size: null
})

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    assign(state) {
      const env = Env.report()
      console.log('ENV', env)
      state.orientation = env.orientation
      state.screen_size = env.screen_size
      state.scroll_offset = env.scroll_offset
      state.window_size = env.window_size
    },
    reset(state) {
      Object.assign(state, initialState())
    }
  }
}
